import { Store } from '@/ts/store';
import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  
  
  {path: '/',         name: 'home',    component: () => import('@/page/index.vue')},  
  {path: '/profile',  name: 'profile',  beforeEnter: [logged], component: () => import('@/page/profile.vue')},
  
  {path: '/support',  name: 'support',  beforeEnter: [logged], component: () => import('@/page/support/general/index.vue'),
    children:[
      {path: ':id',  name: 'support/chat',  beforeEnter: [logged], component: () => import('@/page/support/general/chat.vue')},   
    ],
  },
  
  {path: '/certify',  name: 'certify',  beforeEnter: [logged], component: () => import('@/page/support/assets/index.vue'),
    children:[
      {path: ':id',  name: 'certify/chat',  beforeEnter: [logged], component: () => import('@/page/support/assets/chat.vue')},   
    ],
  },
  
  // {path: '/cert',  name: 'cert',  beforeEnter: [logged], component: () => import('@/page/cert/index.vue'),
  //   children:[
  //     {path: ':id',  name: 'cert/chat',  beforeEnter: [logged], component: () => import('@/page/cert/chat.vue')},   
  //   ],
  // },
  // {path: '/support/:id',  name: 'support/chat',  beforeEnter: [logged], component: () => import('@/page/support/chat.vue')},  
  // {path: '/support/user/:id',  name: 'support/user',  beforeEnter: [logged], component: () => import('@/page/support/user.vue')},
  
  {path: '/tasks',  name: 'tasks',  beforeEnter: [logged], component: () => import('@/page/tasks/index.vue')},
  {path: '/tasks/:id',  name: 'task',  beforeEnter: [logged], component: () => import('@/page/tasks/task.vue')},

  {path: '/developers',  name: 'developers', component: () => import('@/page/developers/index.vue'),    
    children: [
      {path: 'api/mobile/auth',         name: 'developers/api/auth', component: () => import('@/page/developers/api/auth.vue')},
      {path: 'api/mobile/accounts',     name: 'developers/api/accounts', component: () => import('@/page/developers/api/accounts.vue')},
      {path: 'api/mobile/geo',          name: 'developers/api/geo', component: () => import('@/page/developers/api/geo.vue')},
      {path: 'api/mobile/marketplace',  name: 'developers/api/marketplace', component: () => import('@/page/developers/api/marketplace.vue')},
      {path: 'api/mobile/dicts',        name: 'developers/api/dicts', component: () => import('@/page/developers/api/dicts.vue')},
      {path: 'api/mobile/assets',       name: 'developers/api/assets', component: () => import('@/page/developers/api/assets.vue')},
      {path: 'api/mobile/chat',         name: 'developers/api/chat', component: () => import('@/page/developers/api/chat.vue')},
      {path: 'api/mobile/files',        name: 'developers/api/files', component: () => import('@/page/developers/api/files.vue')},
      {path: 'api/mobile/news',         name: 'developers/api/news', component: () => import('@/page/developers/api/news.vue')},
      
      {path: 'api/private/auth',        name: 'developers/api/private/auth', component: () => import('@/page/developers/api/private/auth.vue')},
    ]
  },
  // {path: '/developers/api',  name: 'developers/api', component: () => import('@/page/developers/api/index.vue'),
  //   children: [
  //     {path: 'auth',  name: 'developers/api/auth', component: () => import('@/page/developers/api/auth.vue')},
  //     {path: 'accounts',  name: 'developers/api/accounts', component: () => import('@/page/developers/api/accounts.vue')},
  //     {path: 'geo',  name: 'developers/api/geo', component: () => import('@/page/developers/api/accounts.vue')},
  //   ]
  // },
  
  
  {path: '/team',  name: 'team',  beforeEnter: [logged,god], component: () => import('@/page/team/index.vue'),   },
  
  {path: '/gpt',  name: 'gpt',  beforeEnter: [logged,god], component: () => import('@/page/gpt/index.vue'), 
    children:[
      {path: '',  name: 'gpt/home',  beforeEnter: [logged,god], component: () => import('@/page/gpt/Home.vue')},
      {path: 'user',  name: 'gpt/user',  beforeEnter: [logged,god], component: () => import('@/page/gpt/User.vue')},
      {path: 'models',  name: 'gpt/models',  beforeEnter: [logged,god], component: () => import('@/page/gpt/Models.vue')},
    ],
  },
  
   // accounts
   {path: '/accounts',      name:'accounts', beforeEnter: [logged], component: () => import('@/page/accounts/index.vue'),
    // children: [        
    //     {path: ':id',     name: 'accounts/page',    beforeEnter: [logged],  component: () => import('@/page/accounts/page/index.vue'),
    //       children: [
    //         {path: 'assets',  name: 'accounts/page/assets',  beforeEnter: [logged],  component: () => import('@/page/accounts/page/assets.vue')},
    //         {path: 'support',  name: 'accounts/page/support',  beforeEnter: [logged],  component: () => import('@/page/accounts/page/support.vue')},
    //         {path: 'history',  name: 'accounts/page/history',  beforeEnter: [logged],  component: () => import('@/page/accounts/page/history.vue')},
    //       ]
    //     },
    //     // {path: 'search',  name: 'accounts/search',  beforeEnter: [logged],  component: () => import('@/page/accounts/search.vue')},
    //     // {path: 'new',     name: 'accounts/create',  beforeEnter: [logged],  component: () => import('@/page/accounts/create.vue')},        
    // ]
  },


   // assets
   {path: '/assets',      name:'assets', beforeEnter: [logged], component: () => import('@/page/assets/index.vue')},
   {path: '/assets/:id',  name: 'assets/page',  beforeEnter: [logged],  component: () => import('@/page/assets/page/index.vue')},
   
  
  // news
   {path: '/news',      name:'news', beforeEnter: [logged], component: () => import('@/page/news/index.vue'),
    children: [              
      {path: ':id',  name: 'news/page',  beforeEnter: [logged],  component: () => import('@/page/news/index.vue')},  
      // {path: ':category',   name: 'assets/category',  beforeEnter: [logged],  component: () => import('@/page/assets/category.vue')},  
      
    ]
  },
  
  
  // docs
   {path: '/docs',      name:'docs', beforeEnter: [logged], component: () => import('@/page/docs/index.vue')},
   {path: '/doc/:id',  name: 'docs/page',  beforeEnter: [logged],  component: () => import('@/page/docs/view.vue')},   

  // assets category
  {path: '/category/:category',  name: '',    beforeEnter: [logged],  component: () => import('@/page/category/index.vue'),
      children: [
        {path: 'home',      name: 'category/home',      beforeEnter: [logged],  component: () => import('@/page/category/RootHome.vue')},
        {path: 'attr',      name: 'category/attr',      beforeEnter: [logged],  component: () => import('@/page/category/settings.vue')},
        {path: 'assets',    name: 'category/assets',    beforeEnter: [logged],  component: () => import('@/page/category/assets.vue')},        
        {path: 'settings',  name: 'category/settings',  beforeEnter: [logged],  component: () => import('@/page/category/settings.vue')},
        {path: 'gpt',       name: 'category/gpt',       beforeEnter: [logged],  component: () => import('@/page/category/gpt.vue')},
        {path: 'marketcap', name: 'category/marketcap',       beforeEnter: [logged],  component: () => import('@/page/category/MarketCap.vue')},
        {path: 'brands',    name: 'category/brands',    beforeEnter: [logged],  component: () => import('@/page/category/RootBrands.vue'),
          children:[
            {path: ':brandname/:brand',     name: 'category/models',    beforeEnter: [logged],  component: () => import('@/page/category/RootModels.vue'),
              children:[
                {path: ':modelname/:model',     name: 'category/submodels',    beforeEnter: [logged],  component: () => import('@/page/category/RootSubModels.vue')},
              ],
            },
          ],
        },

        {path: 'dict/:dictname',     name: 'category/dict',    beforeEnter: [logged],  component: () => import('@/page/category/DictEdit.vue')},
      ]
  },
   
  // air
   {path: '/dict',                      name: 'dict',           beforeEnter: [logged,god],   component: () => import('@/page/dict/index.vue'),
    children: [
        // {path: ':title/:id',            name: 'dict/category',  beforeEnter: [logged,god],  component: () => import('@/page/dict/category.vue')},
        {path: 'brands',                name: 'dict/brands',    beforeEnter: [logged,god],  component: () => import('@/page/dict/brands.vue')},
        {path: 'categories',            name: 'dict/categories',beforeEnter: [logged,god],  component: () => import('@/page/dict/categories.vue')},
        {path: 'brand/:title/:id',      name: 'dict/brand',     beforeEnter: [logged,god],  component: () => import('@/page/dict/brand.vue')},
        {path: 'artists',               name: 'dict/artists',   beforeEnter: [logged,god],  component: () => import('@/page/dict/artists.vue')},
        {path: ':id',                   name: 'dict/page',      beforeEnter: [logged,god],  component: () => import('@/page/dict/dict.vue')},
        
    ]
  },

  
]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


function notlogged(to: any, from: any, next: any) {
  const db = Store()
  const profile: any = db.profile
  if (!profile.id){
    next()
  } else{
    next({ name: 'profile'})
  }
}


function logged(to: any, from: any, next: any) {
  const db = Store()
  const profile: any = db.profile
  if (profile.id){
    next()
  } else{
    next({ name: 'home' })
  }
}

function god(to: any, from: any, next: any) {
  const db = Store()
  // const profile: any = db.profile
  console.log("god", db.profile)
  if (db.god){
    next()
  } else{
    next({ name: 'home' })
  }
}


export default router
